import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { X, Check } from 'lucide-react';
export function UpsellComparison() {
  const comparisons = [{
    situation: 'Berrinche en el súper',
    without: 'Te paralizás, cedés o gritás',
    with: 'Usás el protocolo de 90 segundos y lo calmás'
  }, {
    situation: 'Hora de dormir',
    without: 'Lucha de 2 horas cada noche',
    with: 'Rutina visual y a dormir en paz'
  }, {
    situation: 'Cuando te dice "no"',
    without: 'Entrás en una lucha de poder',
    with: 'Aplicás límites firmes desde el amor'
  }, {
    situation: 'Tu paciencia',
    without: 'Se agota a las 10 de la mañana',
    with: 'Tenés herramientas para no desbordarte'
  }, {
    situation: 'La culpa',
    without: 'Te vas a dormir sintiéndote la peor mamá',
    with: 'Sabés que estás construyendo su inteligencia emocional'
  }, {
    situation: 'El vínculo',
    without: 'Se desgasta por tantos gritos',
    with: 'Se fortalece porque sos su lugar seguro'
  }];
  return <section className="py-20 md:py-28 bg-offwhite" data-id="element-366">
      <div className="container mx-auto px-4" data-id="element-367">
        <SectionWrapper data-id="element-368">
          <div className="text-center mb-16" data-id="element-369">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-playfair font-bold text-dark-green mb-6" data-id="element-370">
              ¿Qué cambia cuando tenés el sistema?
            </h2>
          </div>
        </SectionWrapper>

        <SectionWrapper delay={0.2} data-id="element-371">
          <div className="max-w-5xl mx-auto" data-id="element-372">
            {/* Desktop Table */}
            <div className="hidden md:block overflow-hidden rounded-2xl border border-sage/20 shadow-sm bg-white" data-id="element-373">
              <table className="w-full text-left border-collapse" data-id="element-374">
                <thead data-id="element-375">
                  <tr data-id="element-376">
                    <th className="p-6 border-b border-sage/20 text-dark-green font-playfair font-bold text-xl bg-cream/50 w-1/3" data-id="element-377">
                      Situación
                    </th>
                    <th className="p-6 border-b border-sage/20 text-terracotta font-poppins font-bold text-center bg-red-50/50 w-1/3" data-id="element-378">
                      Sin el MegaKit
                    </th>
                    <th className="p-6 border-b border-sage/20 text-dark-green font-poppins font-bold text-center bg-sage/10 w-1/3" data-id="element-379">
                      Con el MegaKit
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-380">
                  {comparisons.map((item, index) => <tr key={index} className="border-b border-sage/10 last:border-0 hover:bg-offwhite transition-colors" data-id="element-381">
                      <td className="p-6 text-dark-green/90 font-poppins font-medium text-lg" data-id="element-382">
                        {item.situation}
                      </td>
                      <td className="p-6 text-dark-green/70 font-poppins text-base text-center bg-red-50/30" data-id="element-383">
                        <div className="flex flex-col items-center gap-3" data-id="element-384">
                          <div className="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center" data-id="element-385">
                            <X className="w-5 h-5 text-red-500" data-id="element-386" />
                          </div>
                          <span data-id="element-387">{item.without}</span>
                        </div>
                      </td>
                      <td className="p-6 text-dark-green/90 font-poppins text-base font-medium text-center bg-sage/5" data-id="element-388">
                        <div className="flex flex-col items-center gap-3" data-id="element-389">
                          <div className="w-8 h-8 rounded-full bg-sage/20 flex items-center justify-center" data-id="element-390">
                            <Check className="w-5 h-5 text-dark-green" data-id="element-391" />
                          </div>
                          <span data-id="element-392">{item.with}</span>
                        </div>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>

            {/* Mobile Stacked View */}
            <div className="md:hidden space-y-6" data-id="element-393">
              {comparisons.map((item, index) => <div key={index} className="bg-white rounded-2xl border border-sage/20 shadow-sm overflow-hidden" data-id="element-394">
                  <div className="p-4 bg-cream/50 border-b border-sage/10" data-id="element-395">
                    <h3 className="font-playfair font-bold text-dark-green text-lg text-center" data-id="element-396">
                      {item.situation}
                    </h3>
                  </div>
                  <div className="p-4 bg-red-50/30 border-b border-sage/10 flex items-start gap-3" data-id="element-397">
                    <div className="w-6 h-6 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-398">
                      <X className="w-4 h-4 text-red-500" data-id="element-399" />
                    </div>
                    <div data-id="element-400">
                      <span className="text-xs font-bold text-terracotta uppercase tracking-wider block mb-1" data-id="element-401">
                        Sin el MegaKit
                      </span>
                      <span className="text-dark-green/80 font-poppins text-sm" data-id="element-402">
                        {item.without}
                      </span>
                    </div>
                  </div>
                  <div className="p-4 bg-sage/5 flex items-start gap-3" data-id="element-403">
                    <div className="w-6 h-6 rounded-full bg-sage/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-404">
                      <Check className="w-4 h-4 text-dark-green" data-id="element-405" />
                    </div>
                    <div data-id="element-406">
                      <span className="text-xs font-bold text-dark-green uppercase tracking-wider block mb-1" data-id="element-407">
                        Con el MegaKit
                      </span>
                      <span className="text-dark-green font-poppins text-sm font-medium" data-id="element-408">
                        {item.with}
                      </span>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </SectionWrapper>
      </div>
    </section>;
}